import auth from "../../middlewares/auth";
export const professorListRoute = [
    {
        path: '/professor/list',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/professor/ProfessorList'),
        name: 'professor_list',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/professor/add',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/professor/ProfessorForm'),
        name: 'professor_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/professor/edit/:id',
        component: () => import(/* webpackChunkName: "members" */ '../../views/members/professor/ProfessorForm'),
        name: 'professor_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    }
];